function ForecastHourLabels() {
  return (
    <div data-testid="forecast-hour-labels" className="mb-2 snap-start">
      <div className="flex w-24 flex-col items-end justify-between text-sm font-light">
        <div className="mb-1 h-12"></div>
        <div className="mb-1">Temp</div>
        <div className="mb-1">Precip Chance</div>
        <div className="mb-1">Precip Amt</div>
        <div className="mb-1">Wind</div>
        <div></div>
      </div>
    </div>
  );
}

export default ForecastHourLabels;
